import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { StateProvider } from '../state'
import ButterToast, { POS_TOP, POS_RIGHT } from 'butter-toast'
import { TableContainer } from './org_table/TableContainer'
import { OrganizationContainer } from './org_details/OrganizationContainer'
import { ContextContainer } from './contexts/ContextContainer'

export const App = () => {
  const initialState = {
    tableData: [],
    contacts: [],
    selectedOrg: null,
    reloadSwitch: false,
    showContextTools: false,
    contextToolsLoading: false,
    contextActs: [],
    canvasActs: [],
    contextToolsCoursenum: '',
    contextToolsContextId: '',
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateTable':
        return {
          ...state,
          tableData: action.tableData,
        }
      case 'selectOrg':
        return {
          ...state,
          selectedOrg: action.payload,
        }
      case 'reload':
        return {
          ...state,
          reloadSwitch: action.reload,
        }
      case 'showContextTools':
        return {
          ...state,
          showContextTools: action.showContextTools,
          contextToolsCoursenum: action.contextToolsCoursenum,
        }
      case 'hideContextTools':
        return {
          ...state,
          showContextTools: action.hideContextTools,
        }
      case 'setContextActs':
        return {
          ...state,
          contextActs: action.contextActs,
          canvasActs: action.canvasActs,
          contextToolsCoursenum: action.contextToolsCoursenum,
          contextToolsContextId: action.contextToolsContextId,
        }
      case 'setContextLoading':
        return {
          ...state,
          contextToolsLoading: action.contextToolsLoading,
        }
      case 'setContacts':
        return {
          ...state,
          contacts: action.payload,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <ButterToast
        position={{ vertical: POS_TOP, horizontal: POS_RIGHT }}
        style={{ top: '65px' }}
      />
      <div className="container">
        <h1 className="me-page-title">LTI Organization Key Management</h1>
        <Router>
          <Switch>
            <Route
              exact
              path="/account/admin_lti_org_key_management/-/"
              component={TableContainer}
            />
            <Route
              exact
              path="/account/admin_lti_org_key_management/-/organizations/:orgId"
              component={OrganizationContainer}
            />
            <Route
              path="/account/admin_lti_org_key_management/-/organizations/:orgId/contexts/:contextId"
              component={ContextContainer}
            />
          </Switch>
        </Router>
      </div>
    </StateProvider>
  )
}
